// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommunityInfo_mapCommBtn__RphDD{
  color: #4795DE;
  text-transform: none;
  margin-bottom: 15px;
  margin-top: 22px;
  border-width: 0px;
  background-color: transparent;
  font-size: 15px;
  font-weight: 800;
  outline: none !important;
}
.CommunityInfo_editCommBtn__yPJso {
  display: flex;
  align-items: center;
  margin-top: 5px;
  color: #4795DE;
  text-transform: none;
  border-width: 0px;
  background-color: transparent;
  font-size: 15px;
  font-weight: 800;
  outline: none !important;
}
.CommunityInfo_editCommImg__dUS-1 {
  width: 20px;
  height: 20px;
  margin-right: 6px;
  margin-left: -3px;
}
.CommunityInfo_button__TcIGX {
  outline: none !important;
  box-shadow: none;
  border-width: 0px;
  width: 90px;
  background: linear-gradient(to right, #4795de, #4795de, #065fb3);
  color: #ffffff;
  border-radius: 30px;
  padding: 4px 10px;
  text-transform: none;
  font-family: sans-serif;
  margin: auto;
}
.CommunityInfo_importantMark__C7mIg {
  color: red !important;
}
.CommunityInfo_mapCommunityImage__VUtgh{
  margin-right: 7px;
  height: 17px;
  margin-left: -3px;
}
.CommunityInfo_communityNameInputField__1NroU{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  border-radius: 30px;
  border: 1px solid #707070;
  font-size: 16px;
  height: 40px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 16px;
  padding-right: 16px;
  resize: none;
  color: gray;
}
.CommunityInfo_descriptionInputField__c8O1N{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  border-radius: 20px;
  border: 1px solid #707070;
  font-size: 16px;
  height: 80px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 16px;
  padding-right: 16px;
  resize: none;
  color: gray;
}
.CommunityInfo_CountryStateDropdown__LMj2h{
  width: 100%;
  background-color: white;
  border-radius: 50px;
  border: 1px solid #707070;
  font-size: 16px;
  /* padding-top: 5px;
  padding-bottom: 5px; */
  padding-left: 10px;
  padding-right: 16px;
  color: #707070;
  height: 40px;
}
.CommunityInfo_labelNameDefault__XcN7f{
  color: #373334;
}
.CommunityInfo_labelName__azoM1{
  padding-left: 18px !important;
  margin-top: 10px;
  margin-bottom: 2px;
  color: #373334;
}

.CommunityInfo_mapCommunityHeading__0bks2{
  color: #373334;
  font-size: 18px;
}
.CommunityInfo_closeIcon__gRGeU{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #F3F2F0;
  height: 25px;
  width: 25px;
  border-radius: 30px;
  border-width: 0px;
  padding: 8px;
  outline: none !important;
  margin-top: -5px;
}
`, "",{"version":3,"sources":["webpack://./src/Modules/Moderator/EditCommunity/CommunityInfo.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,gEAAgE;EAChE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf;wBACsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;AAClB","sourcesContent":[".mapCommBtn{\r\n  color: #4795DE;\r\n  text-transform: none;\r\n  margin-bottom: 15px;\r\n  margin-top: 22px;\r\n  border-width: 0px;\r\n  background-color: transparent;\r\n  font-size: 15px;\r\n  font-weight: 800;\r\n  outline: none !important;\r\n}\r\n.editCommBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-top: 5px;\r\n  color: #4795DE;\r\n  text-transform: none;\r\n  border-width: 0px;\r\n  background-color: transparent;\r\n  font-size: 15px;\r\n  font-weight: 800;\r\n  outline: none !important;\r\n}\r\n.editCommImg {\r\n  width: 20px;\r\n  height: 20px;\r\n  margin-right: 6px;\r\n  margin-left: -3px;\r\n}\r\n.button {\r\n  outline: none !important;\r\n  box-shadow: none;\r\n  border-width: 0px;\r\n  width: 90px;\r\n  background: linear-gradient(to right, #4795de, #4795de, #065fb3);\r\n  color: #ffffff;\r\n  border-radius: 30px;\r\n  padding: 4px 10px;\r\n  text-transform: none;\r\n  font-family: sans-serif;\r\n  margin: auto;\r\n}\r\n.importantMark {\r\n  color: red !important;\r\n}\r\n.mapCommunityImage{\r\n  margin-right: 7px;\r\n  height: 17px;\r\n  margin-left: -3px;\r\n}\r\n.communityNameInputField{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  width: 100%;\r\n  border-radius: 30px;\r\n  border: 1px solid #707070;\r\n  font-size: 16px;\r\n  height: 40px;\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n  padding-left: 16px;\r\n  padding-right: 16px;\r\n  resize: none;\r\n  color: gray;\r\n}\r\n.descriptionInputField{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  width: 100%;\r\n  border-radius: 20px;\r\n  border: 1px solid #707070;\r\n  font-size: 16px;\r\n  height: 80px;\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n  padding-left: 16px;\r\n  padding-right: 16px;\r\n  resize: none;\r\n  color: gray;\r\n}\r\n.CountryStateDropdown{\r\n  width: 100%;\r\n  background-color: white;\r\n  border-radius: 50px;\r\n  border: 1px solid #707070;\r\n  font-size: 16px;\r\n  /* padding-top: 5px;\r\n  padding-bottom: 5px; */\r\n  padding-left: 10px;\r\n  padding-right: 16px;\r\n  color: #707070;\r\n  height: 40px;\r\n}\r\n.labelNameDefault{\r\n  color: #373334;\r\n}\r\n.labelName{\r\n  padding-left: 18px !important;\r\n  margin-top: 10px;\r\n  margin-bottom: 2px;\r\n  color: #373334;\r\n}\r\n\r\n.mapCommunityHeading{\r\n  color: #373334;\r\n  font-size: 18px;\r\n}\r\n.closeIcon{\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #F3F2F0;\r\n  height: 25px;\r\n  width: 25px;\r\n  border-radius: 30px;\r\n  border-width: 0px;\r\n  padding: 8px;\r\n  outline: none !important;\r\n  margin-top: -5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mapCommBtn": `CommunityInfo_mapCommBtn__RphDD`,
	"editCommBtn": `CommunityInfo_editCommBtn__yPJso`,
	"editCommImg": `CommunityInfo_editCommImg__dUS-1`,
	"button": `CommunityInfo_button__TcIGX`,
	"importantMark": `CommunityInfo_importantMark__C7mIg`,
	"mapCommunityImage": `CommunityInfo_mapCommunityImage__VUtgh`,
	"communityNameInputField": `CommunityInfo_communityNameInputField__1NroU`,
	"descriptionInputField": `CommunityInfo_descriptionInputField__c8O1N`,
	"CountryStateDropdown": `CommunityInfo_CountryStateDropdown__LMj2h`,
	"labelNameDefault": `CommunityInfo_labelNameDefault__XcN7f`,
	"labelName": `CommunityInfo_labelName__azoM1`,
	"mapCommunityHeading": `CommunityInfo_mapCommunityHeading__0bks2`,
	"closeIcon": `CommunityInfo_closeIcon__gRGeU`
};
export default ___CSS_LOADER_EXPORT___;
